import axios from 'axios'

export default {
    getTickets(filteredBy, filter, page, sorting) {
        var params = {
            filteredBy: filteredBy,
            customer: filter.customer,
            ticket: filter.ticket,
            dateFrom: filter.dateFrom,
            dateTo: filter.dateTo,
            serialNumber: filter.serialNumber,
            page: page,
            sortBy: sorting.sortBy,
            sortOrder: sorting.sortOrder
        };
        return axios.get('/api/servicetickets/escalatedtickets', { params: params })
    },
    getEscalationCounts() {
        return axios.get('/api/servicetickets/escalationcounts');
    },
    getTicketDetail(id) {
        return axios.get(`/api/servicetickets/escalationdialog/${id}`);
    }
}


// WEBPACK FOOTER //
// ./ClientApp/globalapp/escalationdashboard/api.js